// extracted by mini-css-extract-plugin
export default {"modal":"DeleteAccount_modal__aGtMF","title":"DeleteAccount_title__UZPXO"};